import { format } from "date-fns"
import { useDateTranslations } from "./use-date-translations"
import { enUS } from "date-fns/locale"

export const useLocalizedFormat = (): typeof format => {
  const translations = useDateTranslations()
  let customLocale: Locale = enUS
  if (enUS.localize) {
    customLocale = {
      ...enUS,
      localize: {
        ...enUS.localize,
        day: (n: number): string => translations.shortDayNames[n],
        month: (n: number): string => translations.shortMonthsNames[n],
      },
    }
  }

  return (date: Date | number, formatString: string, options?: { locale?: Locale }) => {
    return format(date, formatString, { ...options, locale: customLocale })
  }
}
